import React, { useEffect } from 'react'
import { Menu, Image, Dropdown } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import './MainMenu.scss'
import leftLogo from '../../../../addons/images/EUI.png'
import rightLogoColor from '../../../../addons/images/BRaVE-colors.png'
import rightLogoWhite from '../../../../addons/images/BRaVE-white.png'
import { Link } from 'react-router'
import { paths } from '../../paths'

const mainMenu = (props) => {
  useEffect(() => {
    props.getSubheaderName()
  }, [])

  const handleItemClick = (e, name) => {
    props.getSubheaderName(name)
  }

  const activeItem = props.name

  const returnAbout = (
    <Dropdown
      item
      text='ABOUT'
      simple
      style={props.main && { color: 'white' }}
      >
      <Dropdown.Menu style={{ marginTop: 0 }} className={props.main && 'whiteMenu'}>
        <Dropdown.Item
          as={Link}
          to={'/about/aboutBrave'}
          active={activeItem === '/about/aboutBrave'}
          onClick={() => handleItemClick('aboutBrave')}
          >
          <div style={props.main && { color: 'white' }}>ABOUT BRAVE</div>
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to={'/about/consortium'}
          active={activeItem === '/about/consortium'}
          onClick={() => handleItemClick('consortium')}
          >
          <div style={props.main && { color: 'white' }}>CONSORTIUM</div>
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to={'/about/advisoryBoard'}
          active={activeItem === '/about/advisoryBoard'}
          onClick={() => handleItemClick('advisoryBoard')}
          >
          <div style={props.main && { color: 'white' }}>ADVISORY BOARD</div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>)

  return (
    <div className='MainMenu'>
      <Image className='LeftLogo' src={leftLogo} />
      <Menu secondary className={props.main ? 'DesktopMenu main' : 'DesktopMenu'}>
        {paths.map((path, i) => (path.name !== 'ABOUT')
        ? (<Menu.Item
            key={i}
            as={Link}
            to={!path.disabled && path.to}
            style={props.main && { color: 'white' }}
            active={activeItem === path.active}
            disabled={path.disabled}
            onClick={() => handleItemClick(path.onClick)}
            ><b>{path.name}</b></Menu.Item>)
            : returnAbout)
          }
      </Menu>
      <Link to='/'><Image className='RightLogo' src={props.main ? rightLogoWhite : rightLogoColor} /></Link>
    </div>
  )
}

export default mainMenu

mainMenu.propTypes = {
  activeItem: PropTypes.bool,
  getSubheaderName: PropTypes.func,
  name: PropTypes.string,
  main: PropTypes.bool
}




// WEBPACK FOOTER //
// ./src/layouts/Layout/MainMenu/components/MainMenu.js